import React from "react";
import PropTypes from 'prop-types';

var ShareTwitter = function ShareTwitter(_ref) {
  var _ref$width = _ref.width,
      width = _ref$width === void 0 ? 19 : _ref$width,
      _ref$height = _ref.height,
      height = _ref$height === void 0 ? 15 : _ref$height,
      _ref$fill = _ref.fill,
      fill = _ref$fill === void 0 ? '#1D2327' : _ref$fill;
  return /*#__PURE__*/React.createElement("svg", {
    width: width,
    height: height,
    viewBox: "0 0 19 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.73138 14.144C12.6163 14.144 16.3837 8.70079 16.3837 3.98844C16.3837 3.83531 16.3837 3.68217 16.3764 3.52904C17.1065 3.02787 17.7417 2.39446 18.2455 1.67751C17.5738 1.9629 16.851 2.15083 16.0917 2.24132C16.8656 1.8028 17.457 1.09978 17.7417 0.264504C17.0189 0.675181 16.2158 0.967528 15.3616 1.12762C14.6753 0.431559 13.7042 0 12.6309 0C10.5647 0 8.88546 1.60094 8.88546 3.5708C8.88546 3.84923 8.92197 4.12069 8.98038 4.3852C5.8701 4.23902 3.11028 2.81209 1.26309 0.654299C0.941845 1.18331 0.759317 1.79584 0.759317 2.45014C0.759317 3.68913 1.42372 4.78195 2.42397 5.42233C1.81068 5.40145 1.23389 5.24135 0.730112 4.97685C0.730112 4.99077 0.730112 5.00469 0.730112 5.02557C0.730112 6.75181 2.02241 8.19962 3.73087 8.52677C3.41692 8.6103 3.08837 8.65206 2.74522 8.65206C2.50428 8.65206 2.27065 8.63118 2.04431 8.58942C2.51889 10.0094 3.9061 11.0396 5.54155 11.0674C4.25655 12.028 2.64301 12.5987 0.890737 12.5987C0.591391 12.5987 0.292045 12.5848 0 12.55C1.65005 13.5523 3.62136 14.144 5.73138 14.144Z",
    fill: fill
  }));
};

ShareTwitter.propTypes = {
  width: PropTypes.string,
  height: PropTypes.string,
  fill: PropTypes.string
};
export default ShareTwitter;